var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCheckGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 14,
    fill: "none",
    viewBox: "0 0 25 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M13.768 1.31a1.453 1.453 0 0 1 2.073 2.035l-7.73 9.668a1.454 1.454 0 0 1-2.093.039L.89 7.925A1.453 1.453 0 1 1 2.945 5.87l4.057 4.055 6.727-8.573a.485.485 0 0 1 .039-.043Zm-1.783 9.959 1.783 1.783a1.452 1.452 0 0 0 2.09-.04l7.735-9.667a1.453 1.453 0 1 0-2.114-1.992L14.75 9.926l-.94-.941-1.827 2.284h.002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheckGray);
export default __webpack_public_path__ + "static/media/DoubleCheckGray.4fdfbc55d2fa152aa88a91456adf364f.svg";
export { ForwardRef as ReactComponent };